import { Text } from '@leroy-merlin-br/backyard-react'

interface PriceInstallmentsProps {
  isBranded?: boolean
  installments: {
    amount: number
    value: string
  }
}

const PriceInstallments = ({
  isBranded,
  installments
}: PriceInstallmentsProps) => {
  const hasInstallments = installments.amount > 1

  if (!hasInstallments) {
    return null
  }

  if (isBranded) {
    return (
      <Text
        color="n400"
        size="kilo"
        noMargin
        data-testid="branded-installments"
      >
        <Text as="strong" isBold size="kilo" noMargin>
          {installments.amount}x{' '}
        </Text>
        s/ juros no cartão{' '}
        <Text as="strong" size="kilo" isBold noMargin>
          Celebre!
        </Text>
      </Text>
    )
  }

  return (
    <Text color="n400" size="kilo" isBold noMargin>
      {installments.amount}x de R$ {installments.value} sem juros
    </Text>
  )
}

export default PriceInstallments
